import {
    IConnectionService,
    ISubscription,
    SubscribeState,
    Ulid,
} from "@kase/my-marathon-communication";
import { Signal } from "@preact/signals";
import { uniqByFn } from "~/utils";
import { GuardedValue } from "../interfaces";

export const createSubscribe =
    <T extends { _id: Readonly<Ulid> }>(
        store: Signal<T[]>,
        connection: GuardedValue<IConnectionService>,
        getSubscription: (
            con: IConnectionService,
        ) => ISubscription<Readonly<Ulid>>,
        load: (id: readonly Readonly<Ulid>[]) => Promise<T[]>,
        onRemove?: (ids: readonly Readonly<Ulid>[]) => void,
    ) =>
    async () => {
        const con = connection.value;

        const subscription = getSubscription(con);

        for await (const event of subscription) {
            if (event.kind === SubscribeState.Remove) {
                onRemove?.(event.values);
                store.value = store.value.filter(
                    (item) => !event.values.find((id) => id.equals(item._id)),
                );
            } else {
                const uniqValues = uniqByFn(event.values, (a, b) =>
                    a.equals(b),
                );

                await load(uniqValues);
            }
        }
    };
